<template>
  <ResourcesContent />
</template>

<script setup>
import ResourcesContent from "@/components/profile/ResourcesContent.vue";
</script>
